export const API = {
    CONTACT_FORM: 'https://agmarketingtools.w1-us.cloudjiffy.net/EmailHtml/incoming.php',
    CHECKOUT_FORM : 'https://agmarketingapp.cc/apicrm/encryptionApi.php'
}